import * as tslib_1 from "tslib";
import { encode } from '../jsonEncode';
import { LoginApiUrl } from '@tradingblock/types';
import { LogoutTokenUrl } from '../constants';
export function TryLogin(values, options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const host = options.host || '';
        const loginUrl = host + (options.subdirectory ? options.subdirectory : '') + LoginApiUrl(options.subroot);
        return yield fetch(loginUrl, {
            method: 'post',
            body: JSON.stringify({ encoded: encode(values) }),
            headers: { 'Content-Type': 'application/json' },
        })
            .then(res => res.json())
            .then(json => json);
    });
}
const httpOptions = {
    headers: { Accept: 'application/json' },
};
export const auth = (api) => {
    return {
        logout: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return api.authenticated().post(LogoutTokenUrl, {}, httpOptions);
        }),
    };
};
//# sourceMappingURL=auth.js.map